import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import {
  RenewalFellowshipTable,
  RenewalFellowshipAdminTable
} from "../components/_dashboard/app";

import {
  getRenewalPostDocMentor,
  getRenewalPostDocAdmin
} from "../core/service/renewalPostDoc.service";
// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

export default function RenewalFellowship() {
  const navigate = useNavigate();
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [listRenewalPostDoc, setListRenewalPostDoc] = useState([{}]);
  const { entities } = listRenewalPostDoc;

  const renewalPostDocMentor = async (id) => {
    const data = await getRenewalPostDocMentor(id);
    setListRenewalPostDoc(data);
  };

  const renewalPostDocAdmin = async (id) => {
    const data = await getRenewalPostDocAdmin(id);
    setListRenewalPostDoc(data);
  };

  useEffect(() => {
    if (currentUser.role === ROLE_ADMIN) {
      // navigate("/404", { replace: true });
      renewalPostDocAdmin();
    } else {
      renewalPostDocMentor(id);
    }
  }, []);

  return (
    <Page title="Renewal of Fellowship">
      <Container maxWidth="xl">
        {/* <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Renewal of Fellowship</Typography>
        </Box> */}
        <Grid container spacing={3}>
          {role === ROLE_MENTOR && (
            <Grid item xs={12} md={6} lg={12}>
              <RenewalFellowshipTable renewalList={entities || []} />
            </Grid>
          )}
          {role === ROLE_ADMIN && (
            <Grid item xs={12} md={6} lg={12}>
              <RenewalFellowshipAdminTable renewalList={entities || []} />
            </Grid>
          )}
        </Grid>
      </Container>
    </Page>
  );
}
